import { FormHelperText, TextField } from "@mui/material";
import "./index.css";

const InputText = (props) => {
  const {
    inputClass,
    placeholder,
    name,
    type,
    id,
    value,
    onChange,
    search,
    errors,
    inputProps,
    noBorder, // Nueva prop para controlar los bordes
  } = props;

  const hasErrors = errors && errors.length > 0;

  return (
    <div className="input_wrapper">
      <TextField
        id={id}
        label={placeholder}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        fullWidth
        variant="outlined"
        error={hasErrors}
        margin="none"
        InputLabelProps={{
          shrink: value !== "",
        }}
        sx={{
          backgroundColor: "#FDFEFF",
          borderRadius: "0.6vh",
          "& .MuiOutlinedInput-input": {
            padding: "8px 14px",
          },
          "& .MuiInputLabel-root": {
            transform: "translate(14px, 8px) scale(1)",
            color: "#A696C7",
          },
          "& .MuiInputLabel-shrink": {
            transform: "translate(14px, -9px) scale(0.75)",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#876ABF",
          },
          "& .MuiOutlinedInput-root": {
            // Condicional para los bordes
            ...(noBorder
              ? {
                  "& fieldset": {
                    border: "none", // Sin bordes cuando noBorder es true
                  },
                  "&:hover fieldset": {
                    border: "none",
                  },
                  "&.Mui-focused fieldset": {
                    border: "none",
                  },
                }
              : {
                  "& fieldset": {
                    borderColor: "#876ABF",
                    borderWidth: "0.25vh",
                    borderRadius: "0.6vh",
                    height: "auto",
                  },
                  "&:hover fieldset": {
                    borderColor: "#876ABF",
                    borderWidth: "0.25vh",
                    borderRadius: "0.6vh",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#876ABF",
                    borderWidth: "0.25vh",
                    borderRadius: "0.6vh",
                  },
                }),
            "& input": {
              color: "#A696C7",
              fontFamily: "ProximaNova-semibold",
              fontSize: "1rem",
            },
          },
        }}
        InputProps={inputProps}
      />
      {hasErrors && (
        <FormHelperText>
          {errors.map((option, index) => {
            return (
              <div key={index} className="error">
                {option.error}
              </div>
            );
          })}
        </FormHelperText>
      )}
    </div>
  );
};

export default InputText;
